import RouteNames from '@/router/names';
import store from '@/store';

//User Types
//TODO Discuss 3 and 8

export const OWNER = 2;
export const STAFF = 3;
export const SUPER_ADMIN = 5;
export const RECEPTION = 21;
export const MANAGER = 22;
export const FINANCE = 23;
export const WAITER = 24;

//Order related perms
export const KANBAN_ORDERS_PERM = 5;
export const ORDER_MAP_PERM = 6;
export const MONITORING_DRIVERS_PERM = 7;
export const ORDER_LIST_PERM = 8;
export const VIEW_LAST_2_HOURS_STATS_PERM = 9;
export const VIEW_COURIER_STATS_PERM = 10;
export const VIEW_FINANCIAL_DATA_ON_COURIER_LIST_PERM = 11;
export const EDIT_ORDER_REFUND_PERM = 55;

//Sales related perms
export const SALES_OVERVIEW_PERM = 12;
export const SALES_ACCOUNT_BONUS_PERM = 13;
export const SALES_BUSINESS_LIST_PERM = 14;
export const SALES_VIEW_BUSINESS_DETAILS_PERM = 15;
export const SALES_EDIT_BUSINESS_PERM = 16;
export const SALES_LEADS_PERM = 17;
export const SALES_SETTINGS_PERM = 18;
export const SALES_EDIT_BUSINESS_OPENING_TIME_PERM = 52;
export const SALES_EDIT_BUSINESS_MENU_PERM = 53;

//Consumers related perms
export const CONSUMERS_OVERVIEW_PERM = 19;
export const CONSUMERS_LIST_PERM = 20;
export const CONSUMERS_REVIEW_PERM = 21;
export const CONSUMERS_LEADS_PERM = 22;
export const CONSUMERS_BLOCK_PERM = 54;
export const CONSUMERS_UNBLOCK_PERM = 54;

//HR related perms
export const HR_OVERVIEW_PERM = 27;
export const HR_EMPLOYEES_PERM = 28;
export const HR_LIST_PERM = 29;
export const HR_VIEW_PLANNING_CALENDAR_PERM = 30;
export const HR_CREATE_PLANNING_CALENDAR_PERM = 31;
export const HR_VIEW_PAYROLL_PERM = 32;
export const HR_CREATE_PAYROLL_PERM = 33;

//LOGISTICS related perms
export const LOGISTICS_OVERVIEW_PLANNING_PERM = 34;
export const LOGISTICS_VIEW_PLANNING_PERM = 35;
export const LOGISTICS_VIEW_REVIEWS_PERM = 36;
export const LOGISTICS_VIEW_PAYROLL_PERM = 37;
export const LOGISTICS_CREATE_PAYROLL_PERM = 38;
export const LOGISTICS_KPI_PERM = 39;
export const LOGISTICS_DRIVER_ZONE_PERM = 40;
export const LOGISTICS_DRIVERS_PERM = 59;
export const LOGISTICS_DISPATCH_PERM = 60;

//FINANCE related perms
export const FINANCE_OVERVIEW_PERM = 23;
export const FINANCE_PAYMENT_PERM = 24;
export const FINANCE_CREATE_PAYMENT_PERM = 25;
export const FINANCE_SETTINGS_PERM = 26;
export const FINANCE_CREATE_INVOICE_PERM = 56;

//MARKETING related perms
export const MARKETING_OVERVIEW_PERM = 41;
export const MARKETING_CONFIGURATOR_PERM = 42;
export const MARKETING_CAMPAIGN_PERM = 43;
export const MARKETING_SEO_PERM = 44;
export const MARKETING_KPI_PERM = 45;
export const MARKETING_SETTING_PERM = 46;
export const MARKETING_SETTING_AI_PERM = 47;
export const MARKETING_WEB_CATEGORIES_PERM = 57;
export const MARKETING_MOBILE_CATEGORIES_PERM = 58;

//TASKS related perms
export const TASK_OVERVIEW_PERM = 48;
export const TASK_LIST_PERM = 49;
export const TASK_VIEW_PERM = 50;
export const TASK_SETTINGS_PERM = 51;

//SETTINGS related perms
export const SETTINGS_USER_TEMPLATES = 62;
export const SETTINGS_USERS = 61;

//POS related perms
export const POS_EDIT_BUSINESS_STATUS = 89;
export const POS_EDIT_BUSINESS_MENU = 96;
export const POS_VIEW_BUSINESS_REVIEWS = 97;
export const POS_EDIT_BUSINESS_TOPPINGS = 98;
export const POS_BUSINESS_FINANCE = 99;
export const POS_EDIT_BUSINESS_MENU_ITEM_PRICE = 100;
export const POS_VIEW_DISCOUNTS = 103;
export const POS_BUSINESS_EXTRA_DELIVERY_TIME = 135;
export const B2B_VIEW_COMPANY_LIST = 105;
export const B2B_VIEW_COMPANY_EMPLOYEES_LIST = 106;
export const B2B_VIEW_COMPANY_DETAILS = 107;
export const B2B_EDIT_COMPANY = 108;
export const B2B_EDIT_COMPANY_STATUS = 109;
export const B2B_SAVE_EDIT_COMPANY_GROUPS = 110;
export const B2B_BUSINESS_SAVE_EDIT_EMPLOYEES = 111;
export const B2B_EDIT_COMPANY_FEATURES = 112;
export const B2B_EDIT_COMPANY_ORDERING_TIMES = 113;
export const B2B_COMPANY_BUDGET = 114;
export const B2B_VIEW_ORDERS = 115;
export const POS_EDIT_BUSINESS_MENU_CATEGORY = 138;
export const POS_B2B_VIEW_ORDERS = 141;
export const ACCOUNT_RECORDS = 143;
export const B2B_SENSITIVE_COMPANY_DETAILS = 171;

export const checkHasPermission = (permissions) => {
	let hasPerm = !permissions;
	if (hasPerm) {
		return true;
	}
	if (store.getters.user?.superAdministrator) {
		return true;
	}
	if (store.getters.user?.perms) {
		const perms = store.getters.user.perms;
		permissions.map((permission) => {
			hasPerm = hasPerm || (perms && perms[permission]);
		});
		return hasPerm;
	}
	return false;
};

export const checkUserTypeAccess = (userTypes) => {
	const userType = store.getters.user?.type;
	return userTypes?.includes(userType);
};

export const hasPermission = ({ next, router }, permissions, userTypes) => {
	if (checkHasPermission(permissions) || checkUserTypeAccess(userTypes)) {
		return next();
	}
	return router.push({ name: RouteNames.Home }).catch(() => {});
};
